<script setup>
import {Bars4Icon, EnvelopeIcon} from '@heroicons/vue/20/solid';
    import MainMenuSearchItemComponent from './MainMenuSearchItemComponent.vue';
    import MainMenuContactItemComponent from './MainMenuContactItemComponent.vue';
import {ref} from 'vue';

    const emit = defineEmits([
        'toggle-menu',
    ]);

    const menuToggler = ref(null);

    const toggleMenu = () => {
        menuToggler.value.classList.toggle('menu-open');
        emit('toggle-menu');
    };

</script>

<template>
    <div ref="menuToggler"
        id="hamburgerMenu"
         class="menu-indicator flex lg:hidden items-center z-100 font-bold">
        <a class="relative w-8" href="#" @click.prevent.stop="toggleMenu">
            <div class="transition duration-300 ease-in-out">
                <span class="block relative w-full transition duration-300 ease-in-out"></span>
            </div>
            <div class="transition duration-300 ease-in-out">
                <span class="block relative w-full transition duration-300 ease-in-out"></span>
            </div>
            <div class="transition duration-300 ease-in-out">
                <span class="block relative w-full transition duration-300 ease-in-out"></span>
            </div>
        </a>
    </div>
</template>

<style scoped>

</style>
